import React from 'react';
import { getDay, parseISO } from 'date-fns';
import { View, StyleSheet, TouchableWithoutFeedback, } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { AccentContainer } from 'design-system/AccentContainer';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { isWeb } from '../../constants';
import { FIRST_DAY } from './types';
const EdgeDayText = ({ isToday, children }) => isToday ? (<Text Numbers-16 White>
        {children}
      </Text>) : (<Text Numbers-14 White>
        {children}
      </Text>);
const DayText = ({ isToday, children, }) => isToday ? (<Text Numbers-16 Gray>
      {children}
    </Text>) : (<Text Numbers-14 Gray>
      {children}
    </Text>);
export const Day = React.memo(({ isInRange, date, onDayPress, isToday, isEndDay, isStartDay, isDisabled, inRangeMaskStyle, }) => {
    const styles = useStyles(styleSet);
    const isEdgeDay = isStartDay || isEndDay;
    const isWeekStartDay = getDay(parseISO(date.dateString)) === (FIRST_DAY ?? 1);
    const isWeekEndDay = getDay(parseISO(date.dateString)) ===
        ((FIRST_DAY ?? 1) - 1 < 0 ? 6 : (FIRST_DAY ?? 1) - 1);
    const inRangeStyle = [
        styles.inRangeMask,
        isWeb && isWeekEndDay && !isEndDay && styles.inRangeMaskSunday,
        isStartDay && styles.startDayMask,
        isEndDay && styles.endDayMask,
        isWeb && isEndDay && isWeekStartDay && styles.inRangeMaskMondayEnd,
        isInRange && !isStartDay && isWeekStartDay && styles.leftBorderRadius,
        isInRange && !isEndDay && isWeekEndDay && styles.rightBorderRadius,
    ].filter(Boolean);
    return (<TouchableWithoutFeedback onPress={() => {
            if (!isDisabled && onDayPress) {
                onDayPress(date);
            }
        }}>
        <View style={styles.flexContainer}>
          <View style={[
            styles.container,
            isDisabled && !isInRange && styles.disabled,
        ]}>
            {isInRange ? (<View style={[inRangeStyle, inRangeMaskStyle]}/>) : null}
            <AccentContainer style={[
            styles.dayContainer,
            inRangeMaskStyle,
            isEdgeDay && styles.edgeRangeDay,
        ]}>
              {isEdgeDay ? (<EdgeDayText isToday={isToday}>{date?.day}</EdgeDayText>) : (<DayText isToday={isToday}>{date?.day}</DayText>)}
            </AccentContainer>
          </View>
        </View>
      </TouchableWithoutFeedback>);
});
const styleSet = createStyleSheets((colors) => {
    const dayCircleSize = rem(38.5);
    return {
        flexContainer: {
            flexDirection: 'row',
            ...(isWeb && { cursor: 'pointer' }),
        },
        container: {
            flex: 1,
            minHeight: dayCircleSize,
            alignItems: 'center',
        },
        edgeRangeDay: {
            backgroundColor: colors.elements.brand,
            borderRadius: rem(50),
        },
        dayContainer: {
            borderRadius: 50,
            width: dayCircleSize,
            height: dayCircleSize,
            justifyContent: 'center',
            alignItems: 'center',
        },
        inRangeMask: {
            ...StyleSheet.absoluteFillObject,
            backgroundColor: colors.background.dark,
            ...(isWeb && { width: '230%' }),
        },
        inRangeMaskSunday: {
            width: '100%',
        },
        startDayMask: {
            left: dayCircleSize / 2,
            borderTopLeftRadius: rem(50),
            borderBottomLeftRadius: rem(50),
            ...(isWeb && { left: 0 }),
        },
        endDayMask: {
            right: dayCircleSize / 2,
            borderTopRightRadius: rem(50),
            borderBottomRightRadius: rem(50),
            ...(isWeb && { width: 0 }),
        },
        leftBorderRadius: {
            borderTopLeftRadius: rem(8),
            borderBottomLeftRadius: rem(8),
        },
        rightBorderRadius: {
            borderTopRightRadius: rem(8),
            borderBottomRightRadius: rem(8),
        },
        inRangeMaskMondayEnd: {
            width: '100%',
            borderTopRightRadius: 50,
            borderBottomRightRadius: 50,
        },
        disabled: {
            opacity: 0.5,
        },
    };
});
